module.exports = __webpack_public_path__ + "img/intro_5.4d907c6e.jpeg";